// package: favorite
// file: apigateway/favorite/blog.proto

import * as apigateway_favorite_blog_pb from "../../apigateway/favorite/blog_pb";
export class BlogFavoriteService {
  static serviceName = "favorite.BlogFavoriteService";
}
export namespace BlogFavoriteService {
  export class GetFavoriteBlogs {
    static readonly methodName = "GetFavoriteBlogs";
    static readonly service = BlogFavoriteService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_favorite_blog_pb.GetFavoriteBlogsRequest;
    static readonly responseType = apigateway_favorite_blog_pb.GetFavoriteBlogsReply;
  }
  export class AddBlogFavorite {
    static readonly methodName = "AddBlogFavorite";
    static readonly service = BlogFavoriteService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_favorite_blog_pb.AddBlogFavoriteRequest;
    static readonly responseType = apigateway_favorite_blog_pb.AddBlogFavoriteReply;
  }
  export class DeleteBlogFavorite {
    static readonly methodName = "DeleteBlogFavorite";
    static readonly service = BlogFavoriteService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_favorite_blog_pb.DeleteBlogFavoriteRequest;
    static readonly responseType = apigateway_favorite_blog_pb.DeleteBlogFavoriteReply;
  }
}
